module.exports = __webpack_public_path__ + "static/media/Ignatia-Wildsmith.ef483545.png";